import runtimeConfig from '../../runtime.config.js'

const ACCESS_TOKEN_KEY = 'aime_token'
const DATA_TRADER_STORAGE_KEY = 'dataTrader'
const USER_PREFIX_STORAGE_KEY = 'prefix'
const DATA_TRADER_PREFIX_STORAGE_KEY = 'dataTraderPrefix'

export const isEmbedMode = () => runtimeConfig.embedMode === true

export const isStandaloneMode = () => !isEmbedMode()

export const isSsoAuthMode = () => runtimeConfig.authMode === 'sso'

export const getCookie = (name) => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) {
    return decodeURIComponent(parts.pop().split(';').shift() || '')
  }
  return ''
}

export const setCookie = (name, value, days = 30) => {
  const expires = new Date()
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`
}

export const removeCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
}

export const getAccessToken = () => {
  return localStorage.getItem(ACCESS_TOKEN_KEY) || ''
}

export const hasAccessToken = () => Boolean(getAccessToken())

export const persistAccessToken = (token) => {
  if (!token) {
    return
  }
  localStorage.setItem(ACCESS_TOKEN_KEY, token)
}

export const clearAccessToken = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
}

export const clearUserSession = () => {
  clearAccessToken()
  removeCookie('token')
  removeCookie('prefix')
  localStorage.removeItem('account')
  localStorage.removeItem(USER_PREFIX_STORAGE_KEY)
  localStorage.removeItem(DATA_TRADER_STORAGE_KEY)
  localStorage.removeItem(DATA_TRADER_PREFIX_STORAGE_KEY)
  localStorage.removeItem('userinfo')
  localStorage.removeItem('enterprise')
  localStorage.removeItem('aime_button_permissions')
  localStorage.removeItem('defaultDataTrader')
  localStorage.removeItem('PT_USERMENULIST')
  sessionStorage.removeItem('dataTraderId')
  sessionStorage.removeItem('dataTraderName')
  sessionStorage.removeItem('dataTraderType')
  sessionStorage.removeItem('dataTraderPrefix')
  sessionStorage.removeItem('menuId')
  sessionStorage.removeItem('isAdmin')
  sessionStorage.removeItem('postLoginTarget')
}

export const saveDataTraderCache = (dataTrader) => {
  if (!dataTrader) {
    localStorage.removeItem(DATA_TRADER_STORAGE_KEY)
    localStorage.removeItem(DATA_TRADER_PREFIX_STORAGE_KEY)
    return
  }
  const normalizedTrader = {
    dataTraderType: dataTrader.dataTraderType,
    dataTraderId: dataTrader.dataTraderId,
    dataTraderPrefix: dataTrader.dataTraderPrefix || dataTrader.nowPrefix || '',
    nowPrefix: dataTrader.dataTraderPrefix || dataTrader.nowPrefix || '',
    dataTraderName: dataTrader.dataTraderName || ''
  }
  localStorage.setItem(DATA_TRADER_STORAGE_KEY, JSON.stringify(normalizedTrader))
  localStorage.setItem(DATA_TRADER_PREFIX_STORAGE_KEY, normalizedTrader.dataTraderPrefix)
}

export const getDataTraderCache = () => {
  const traderStr = localStorage.getItem(DATA_TRADER_STORAGE_KEY) || ''
  if (!traderStr) {
    return null
  }
  try {
    return JSON.parse(traderStr)
  } catch {
    return null
  }
}

export const gotoStandaloneLogin = (target = '/home') => {
  if (isEmbedMode()) {
    return
  }
  const encodedTarget = encodeURIComponent(target)
  window.location.href = `/#/login?target=${encodedTarget}`
}

export const getLoginEntryUrl = () => (isEmbedMode() ? '/login.html' : '/#/login')
